import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import './style.css'
import ThankYouForYourRegistration from './views/thank-you-for-your-registration'
import Home from './views/home'
import HomeBackup from './views/home-backup'
import ReactGA from 'react-ga4';

ReactGA.initialize('G-0VBBCG4Q80');

const App = () => {
  return (
    <Router>
      <div>
        <Route
          component={ThankYouForYourRegistration}
          exact
          path="/thank-you-for-your-registration"
        />
        <Route component={Home} exact path="/" />
        <Route component={HomeBackup} exact path="/home-backup" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
